<template>
	<div id="consultationCard">

	  	<div class="p-5">
		  	<vx-card>
		  		<h1>{{ $t('cartao_de_consulta') }}</h1>
		  		<h3 class="mt-5">{{ $t('bem_vindo_satsanga') }}</h3>
		  		<p>{{ $t('preencha_frase') }}</p>
				<div v-show="event_name && therapist_name">
					<h5 class="mt-5">{{ $t('massagem_tratamento') }}</h5>
					<p>{{ event_name }}</p>
					<h5 class="mt-5">{{ $t('terapeuta') }}</h5>
					<p>{{ therapist_name }}</p>
				</div>
		  	</vx-card>
		</div>
		<div class="p-5" v-if="form_answered">
		  	<vx-card>
		  		<h4 class="mt-5 mb-5 text-center">{{ $t('agradecemos_questionario') }}</h4>
		  	</vx-card>
		</div>
		<div v-else>
			<div class="pr-5 pl-5 pb-5">
			  	<vx-card>
			  		<h3 class="mb-3">{{ $t('informacao_pessoal') }}</h3>

			  		<label class="" style="font-size: 10px; color:#ababab;" for="person-name">{{ $t('nome') }}</label>
			  		<vs-input 
			  			id="person-name"
			  			class="sm:w-full lg:w-1/3 pb-2" 
			  			:disabled="person['is_staff'] == null || person['is_staff'] == true || consultation_card_id != null" 
			  			v-model="person['nome']" />

			  		<span class="" style="font-size: 10px; color:#ababab;">{{ $t('data_de_nascimento') }}</span>
			  		<datepicker 
			  			class="pb-2" 
			  			:disabled="person['is_staff'] == null || person['is_staff'] == true || consultation_card_id != null" 
			  			:disabledDates="disabledDates"
			  			v-model="person['data_nascimento']" 
			  			format="dd/MM/yyyy">
			  		</datepicker>

			  		<span class="" style="font-size: 10px; color:#ababab;">{{ $t('pais') }}</span>
			  		<v-select 
						class="pb-2 sm:w-full lg:w-1/3 vue-select" 
						placeholder='Pais' 
			  			:disabled="person['is_staff'] == null || person['is_staff'] == true || consultation_card_id != null" 
						v-model="person['country']" 
						:options="paises_avaliable" 
						label="pais"
						:clearable="false"/>
			  		
			  		<label class="" style="font-size: 10px; color:#ababab;" for="person-contacto">{{ $t('contacto') }}</label>
			  		<vs-input 
			  			id="person-contacto"
					  	type="number"
			  			class="pb-2" 
			  			:disabled="person['is_staff'] == null || person['is_staff'] == true || consultation_card_id != null"
			  			v-model="person['telefone']" />

			  		<label class="" style="font-size: 10px; color:#ababab;" for="person-email">Email</label>
			  		<vs-input 
			  			id="person-email"
			  			class="sm:w-full lg:w-1/3 mb-3" 
			  			:disabled="person['is_staff'] == null || person['is_staff'] == true || consultation_card_id != null"
			  			v-model="person['email']" />

			  		<div class="w-full pt-5 pb-3">
				  		<div v-for="(type, key) in client_type_avaliable" :key="key">
				  			<vs-radio v-model="form['client_type_id']" vs-name="client_type" :vs-value="type.client_type_id" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-radio>
				  			<label 
					  			v-show="form['client_type_id'] == 3 && type.client_type_id == 3"
					  			style="font-size: 10px; color:#ababab; margin-top: 5px; display: block;"
					  			for="n_quarto">
					  				{{ $t('n_quarto') }}
					  		</label>
				  			<vs-input 
				  				id="n_quarto"
						  		type="number"
					  			class="pb-4" 
					  			:disabled="consultation_card_id != null"
					  			v-show="form['client_type_id'] == 3 && type.client_type_id == 3"
					  			v-model="form['client_type_room']"
					  		/>
					  		<span class="errors" v-show="form['client_type_id'] == 3 && type.client_type_id == 3 && errors_form.n_quarto">
					  			{{ $t('campo_obrigatorio') }}
					  		</span>
				  		</div>
				  	</div>

			  		<p class="pt-5"><b>{{ $t('tomou_conhecimento_spa') }}</b></p>
			  		<div class="w-full pt-2">
				  		<div v-for="(type, key) in aware_types_avaliable" :key="key">
				  			<vs-radio v-model="form['aware_type_id']" vs-name="aware_type" :vs-value="type.aware_type_id" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-radio>
				  			<label 
					  			v-show="form['aware_type_id'] == 6 && type.aware_type_id == 6"
					  			style="font-size: 10px; color:#ababab; margin-top: 5px; display: block;">
					  				{{ $t('qual') }}
					  		</label>
					  		<vs-input 
					  			class="w-full pt-1" 
					  			:disabled="consultation_card_id != null"
					  			v-show="form['aware_type_id'] == 6 && type.aware_type_id == 6"
					  			v-model="form['aware_type_other']" />
				  		</div>
			  		</div>
			  	</vx-card>
			</div>
			<div class="pr-5 pl-5 pb-5">
			  	<vx-card>
			  		<h3 class="">{{ $t('informacoes_medicas') }}</h3>
			  		<div class="pt-5">
				  		<div class="pt-1" v-for="(type, key) in medical_info_types_avaliable" :key="key">
				  			<vs-checkbox v-model="type.selected" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-checkbox>
				  			<label 
					  			v-show="type.has_input == 1 && type.selected == true"
					  			style="font-size: 10px; color:#ababab; margin-top: 5px; display: block;">
					  				{{ $t(type.label) }}
					  		</label>
				  			<vs-input 
						  		type="text"
					  			class="sm:w-full lg:w-1/6 pt-2 pb-4" 
					  			:disabled="consultation_card_id != null"
					  			v-show="type.has_input == 1 && type.selected == true && type.input_type == 'TEXT'"
					  			v-model="type.observations" 
					  		/>
					  		<vs-input 
						  		type="number"
					  			class="sm:w-full lg:w-1/6 pt-2 pb-4" 
					  			:disabled="consultation_card_id != null"
					  			v-show="type.has_input == 1 && type.selected == true && type.input_type == 'NUMBER'"
					  			v-model="type.observations" 
					  			min="0"
					  			oninput="validity.valid||(value='');"
					  		/>
					  		<vs-textarea 
					  			style="width:100%"
					  			class="w-full pt-2 pb-4" 
					  			rows="2"
					  			:disabled="consultation_card_id != null"
					  			v-show="type.has_input == 1 && type.selected == true && type.input_type == 'TEXTAREA'"
					  			v-model="type.observations" 
					  		/>
					  		<span class="errors" v-show="type.has_input == 1 && type.selected == true && type.medical_info_type_id == 14 && errors_form.semanas">
					  			{{ $t('campo_obrigatorio') }}
					  		</span>
					  		<span class="errors" v-show="type.has_input == 1 && type.selected == true && type.medical_info_type_id == 16 && errors_form.desc_alergias">
					  			{{ $t('campo_obrigatorio') }}
					  		</span>
					  		<span class="errors" v-show="type.has_input == 1 && type.selected == true && type.medical_info_type_id == 17 && errors_form.desc_outras">
					  			{{ $t('campo_obrigatorio') }}
					  		</span>
				  		</div>
			  		</div>
			  	</vx-card>
			</div>
			<div class="pr-5 pl-5 pb-5">
			  	<vx-card>
			  		<h3 class="">{{ $t('tratamento_de_corpo') }}</h3>
			  		<p class="pb-3" v-show="consultation_card_id == null">
			  			{{ $t('marque_frase') }} <span class="inline-block"><img src="@/assets/images/pages/body/cross.png" alt="cross"/></span> {{ $t('marque_frase_2') }} <span class="inline-block"><img src="@/assets/images/pages/body/check.png" alt="check"/></span>
			  		</p>
			  		<div class="pb-3" v-show="consultation_card_id == null">
				  		<vs-radio class="pr-5" vs-value="1" v-model="mark.iconCheck" vs-name="mark">
				  			<img src="@/assets/images/pages/body/check.png" alt="check"/>
				  		</vs-radio>
				  		<vs-radio class="pr-5" vs-value="0" v-model="mark.iconCheck" vs-name="mark">
				  			<img src="@/assets/images/pages/body/cross.png" alt="cross"/>
				  		</vs-radio>
			  			<vs-button class="ml-5" v-on:click="bodyImage()">{{ $t('limpar') }}</vs-button>
			  		</div>
			  		
			  		<div id="divCanvas" class="pb-4">
				  		<canvas v-if="consultation_card_id == null" id="canvas" width="670" height="462"></canvas>
				  		<img v-else id="body_image" width="670" height="462" src="" alt="body_image">
				  		<div width="670">
				  			<span style="margin-left: 58px;">{{ $t('direita') }}</span>
				  			<span style="margin-left: 95px;">{{ $t('posterior') }}</span>
				  			<span style="margin-left: 138px;">{{ $t('anterior') }}</span>
				  			<span style="margin-left: 82px;">{{ $t('esquerda') }}</span>
				  		</div>
				  	</div>

			  		<p class="pt-5"><b>{{ $t('pressao_prefere') }}</b></p>
			  		<div class="w-full pt-2">
				  		<div v-for="(type, key) in pressure_types_avaliable" :key="key">
				  			<vs-radio v-model="form['pressure_type_id']" vs-name="pressure_type" :vs-value="type.pressure_type_id" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-radio>
				  		</div>
				  	</div>
			  	</vx-card>
			</div>

			<div class="pr-5 pl-5 pb-5">
			  	<vx-card>
			  		<h3 class="">{{ $t('tratamento_do_rosto') }}</h3>
			  		<p class="pt-5"><b>{{ $t('tipo_de_pele') }}</b></p>
			  		<div class="w-full pt-2">
				  		<div v-for="(type, key) in skin_types_avaliable" :key="key">
				  			<vs-radio v-model="form['skin_type_id']" vs-name="skin_type" :vs-value="type.skin_type_id" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-radio>
				  		</div>
				  	</div>

			  		<p class="pt-5"><b>{{ $t('tratamento_dermatologia') }}</b></p>
			  		<div class="w-full pt-2">
				  		<div v-for="(type, key) in other_treatment_avaliable" :key="key">
				  			<vs-radio v-model="form['other_treatment']" vs-name="other_treatment" :vs-value="type.value" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-radio>
				  			<label 
					  			v-show="form['other_treatment'] == 1 && type.value == 1"
					  			style="font-size: 10px; color:#ababab; margin-top: 5px; display: block;">
					  				{{ $t('qual') }}
					  		</label>
				  			<vs-input 
					  			class="w-full pt-1" 
					  			:disabled="consultation_card_id != null"
					  			v-show="form['other_treatment'] == 1 && type.value == 1"
					  			v-model="form['other_treatment_observation']" 
					  		/>
					  		<span class="errors" v-show="form['other_treatment'] == 1 && type.value == 1 && errors_form.qual">
					  			{{ $t('campo_obrigatorio') }}
					  		</span>
				  		</div>
			  		</div>

			  		<p class="pt-5"><b>{{ $t('condicoes_de_pele') }}</b></p>
			  		<div class="pt-1">
				  		<div class="pt-1" v-for="(type, key) in skin_condition_types_avaliable" :key="key">
				  			<vs-checkbox v-model="type.selected" :disabled="consultation_card_id != null">{{ $t(type.tag) }}</vs-checkbox>
				  		</div>
			  		</div>
			  	</vx-card>
			</div>

			<div class="pr-5 pl-5 pb-5">
			  	<vx-card>
			  		<h3>{{ $t('termos_protecao_dados_pessoais') }}</h3>
			  		<p>
			  			{{ $t('texto_proteção_dados') }}
			  		</p>
			  		<div class="mt-4 flex">
				  		<vs-switch :disabled="consultation_card_id != null" v-model="form.data_protection" icon-pack="feather" vs-icon-off="icon-shield-off" vs-icon-on="icon-shield"/>
				  		<span class="ml-2">{{ $t('compreendo_informacoes') }}</span>
			  		</div>
				  	<span class="errors" style="margin-left: 50px" v-show="errors_form.data_protection">{{ $t('campo_obrigatorio') }}</span>

			  		<div class="mt-4 flex">
				  		<vs-switch :disabled="consultation_card_id != null" v-model="form.true_information" icon-pack="feather" vs-icon-off="icon-shield-off" vs-icon-on="icon-shield"/>
				  		<span class="ml-2">{{ $t('li_e_aceito') }}</span>
			  		</div>
				  	<span class="errors" style="margin-left: 50px" v-show="errors_form.true_information">{{ $t('campo_obrigatorio') }}</span>

			  		<div class="mt-4 flex">
				  		<vs-switch :disabled="consultation_card_id != null" v-model="form.receive_email" icon-pack="feather" vs-icon-off="icon-bell-off" vs-icon-on="icon-bell"/>
				  		<span class="ml-2">{{ $t('autorizo_email') }}</span>
			  		</div>

			  		<div class="mt-4 flex">
				  		<vs-switch :disabled="consultation_card_id != null" v-model="form.receive_sms" icon-pack="feather" vs-icon-off="icon-bell-off" vs-icon-on="icon-bell"/>
				  		<span class="ml-2">{{ $t('autorizo_sms') }}</span>
			  		</div>
			  		
					<div class="text-center">
						<vs-button v-show="consultation_card_id == null" class="mt-5 mb-5" v-on:click="sendForm()">{{ $t('submeter') }}</vs-button>
					</div>
			  	</vx-card>
			</div>
		</div>

	</div>

</template>

<script>

	import Datepicker from 'vuejs-datepicker';
	
	export default {
		data(){
			return {
				event_schedule_id: null,
				event_name: '',
				therapist_name: '',
				cod_pessoa: null,
				consultation_card_id: null,
				form_answered: false,
				mark: {
					iconCheck: 1,
				},
				person: {
					cod_pais: '',
					country: [],
					data_nascimento: '',
					email: '',
					nome: '',
					telefone: null,
					is_staff: null,
				},
				form: {
                    client_type_id: null,
                    client_type_room: '',
                    aware_type_id: null,
                    aware_type_other: '',
                    pressure_type_id: null,
                    skin_type_id: null,
					other_treatment: null,
					other_treatment_observation: '',
					data_protection: null,
					true_information: null,
					receive_email: null,
					receive_sms: null,
					path_body_treatment: '',
                },
                paises_avaliable: [],
                client_type_avaliable: [],
                aware_types_avaliable: [],
                medical_info_types_avaliable: [],
                pressure_types_avaliable: [],
                skin_types_avaliable: [],
                other_treatment_avaliable: [
                	{
                		name: 'Não',
                		value: 0,
                		tag: 'nao',
                	},
                	{
						name: 'Sim',
                		value: 1,
                		tag: 'sim',
                	}
                ],
                skin_condition_types_avaliable: [],
                disabledDates: {
                    to: null, // Disable all dates up to specific date
                    from: null, // Disable all dates after specific date
                },
                errors_form: {
                	n_quarto: false,
                	semanas: false,
                	desc_alergias: false,
                	desc_outras: false,
                	qual: false,
                	true_information: false,
                	data_protection: false
                }
			}
		},
		methods: {
			getForm(){
        		this.$vs.loading();
        		let that = this;
				this.$api({
                    method: 'get',
                    url: '/spa/consultationCard/getForm',
                    params: {
                        token: process.env.VUE_APP_TOKEN,
                        cod_pessoa: 			this.cod_pessoa,
						event_schedule_id: 		this.event_schedule_id,
						consultation_card_id: 	this.consultation_card_id,
                    },
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.person = res.data.user;
                    this.client_type_avaliable = res.data.clientTypes;
                    this.paises_avaliable = res.data.paises;
                    this.medical_info_types_avaliable = res.data.medicalInfoTypes.map(function(value){
                    	value.selected = !!+value.selected;
                    	value.label = 'descricao';
                    	if(['14', '16', '17'].indexOf(value.medical_info_type_id) !== -1){
                    		value.has_input = 1;
                    		if(value.medical_info_type_id == 14){
                    			value.label = 'semanas';
                    			value.input_type = 'NUMBER';
                    		}
                    	}
                    	return value;
                    });
                    this.aware_types_avaliable = res.data.awareTypes;
                    this.pressure_types_avaliable = res.data.pressureTypes;
                    this.skin_types_avaliable = res.data.skinTypes;
                    this.skin_condition_types_avaliable = res.data.skinConditionTypes.map(function(value){
                    	value.selected = !!+value.selected;
                    	return value;
                    });

					if( res.data.eventInfo ){
						this.event_name = res.data.eventInfo.event_name;
						this.therapist_name = res.data.eventInfo.therapist_name;
					}

                    if(typeof res.data.form !== 'undefined'){
                    	// formulario preenchido -> modo consulta
                    	this.updateLocale('pt');
                    	this.form = res.data.form;
						document.getElementById('body_image').src = this.form['path_body_treatment'];

						for (let  i = 0; i < this.medical_info_types_avaliable.length; i++) {
							if(this.medical_info_types_avaliable[i].medical.length > 0){
								this.medical_info_types_avaliable[i].selected = true;
								this.medical_info_types_avaliable[i].observations = this.medical_info_types_avaliable[i].medical[0].observations;
							}
						}
						for (let  i = 0; i < this.skin_condition_types_avaliable.length; i++) {
							if(this.skin_condition_types_avaliable[i].skin_condition.length > 0){
								this.skin_condition_types_avaliable[i].selected = true;
							}
						}
                    }else{
                    	// formulario vazio
	                    this.updateLocale(res.data.language);
                    }

                })
                .catch((err) => {
                    this.$vs.loading.close();
                    this.$router.push({ name: 'pageError404'});
                });
			},
			bodyImage(){
				if(this.consultation_card_id == null){

					let can = document.getElementById("canvas"),
						ctx = can.getContext('2d'),
						img = new Image();

					this.mark.img = new Image();
					this.mark.iconCheck = 1;
					
					img.src = require('@/assets/images/pages/body/body_chart.png');
					
					let that = this;

					img.onload = function(){

						ctx.drawImage(img, 0, 0, 670, 462);

						that.mark.img.src = require('@/assets/images/pages/body/check.png');

						can.onclick= function(evt) {
							let x = evt.offsetX - that.mark.img.width/2,
								y = evt.offsetY - that.mark.img.height/2;
							
							ctx.drawImage(that.mark.img, x, y);
						};
					}
				}
			},
			changeMark(iconCheck){
				this.mark.img.src = require('@/assets/images/pages/body/'+['cross.png', 'check.png'][iconCheck]);
				this.mark.iconCheck = iconCheck;
			},
			sendForm(){
				if(this.form.client_type_id == 3 && this.form.client_type_room == ''){
					this.errors_form.n_quarto = true;
				}else{
					this.errors_form.n_quarto = false;
				}
				if(this.medical_info_types_avaliable[13].selected == true && 
					(this.medical_info_types_avaliable[13].observations == '' ||
					this.medical_info_types_avaliable[13].observations == null)
					){
					this.errors_form.semanas = true;
				}else{
					this.errors_form.semanas = false;
				}
				if(this.medical_info_types_avaliable[15].selected == true && 
					(this.medical_info_types_avaliable[15].observations == '' ||
					this.medical_info_types_avaliable[15].observations == null)
					){
					this.errors_form.desc_alergias = true;
				}else{
					this.errors_form.desc_alergias = false;
				}
				if(this.medical_info_types_avaliable[16].selected == true && 
					(this.medical_info_types_avaliable[16].observations == '' ||
					this.medical_info_types_avaliable[16].observations == null)
					){
					this.errors_form.desc_outras = true;
				}else{
					this.errors_form.desc_outras = false;
				}
				if(this.form.other_treatment == 1 && this.form.other_treatment_observation == ''){
					this.errors_form.qual = true;
				}else{
					this.errors_form.qual = false;
				}

				if(this.form.data_protection == false || this.form.data_protection == null){
					this.errors_form.data_protection = true;
				}else{
					this.errors_form.data_protection = false;
				}
				if(this.form.true_information == false || this.form.true_information == null){
					this.errors_form.true_information = true;
				}else{
					this.errors_form.true_information = false;
				}

				if(this.form.data_protection == true && 
					this.form.true_information == true &&
					this.errors_form.n_quarto == false &&
					this.errors_form.semanas == false &&
					this.errors_form.desc_alergias == false &&
					this.errors_form.desc_outras == false &&
					this.errors_form.qual == false
					){
        			this.$vs.loading();

					let canv = document.getElementById("canvas");

					let that = this;
					this.$api({
						method: 'post',
						url: '/spa/consultationCard/save',
						data: {
							cod_pessoa: 			this.cod_pessoa,
							event_schedule_id: 		this.event_schedule_id,
							token: 					process.env.VUE_APP_TOKEN,
							person: 				this.person,
							form: 					this.form,
							medical_info: 			this.medical_info_types_avaliable,
							skin_condition: 		this.skin_condition_types_avaliable,
							image: 					canv.toDataURL(),
						},
					})
					.then(function (res) {
						that.form_answered = true;
					}) 
					.catch( function (err) {
						that.notify(err.response.data.message, 'red', 10);
					})
					.then(function() {
						that.$vs.loading.close();
					});
				}
                
			}
		},
		created(){
			if(typeof this.$route.params.event_schedule_id !== 'undefined' && typeof this.$route.params.cod_pessoa !== 'undefined'){
				this.event_schedule_id = this.$route.params.event_schedule_id;
				this.cod_pessoa = this.$route.params.cod_pessoa;
				if(typeof this.$route.params.consultation_card_id !== 'undefined'){
					this.consultation_card_id = this.$route.params.consultation_card_id;
				}
				this.getForm();
			}
			let d = new Date();
            this.dataHoje = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            this.disabledDates.from = this.dataHoje;
		},
		mounted(){
			this.bodyImage();
		},
		watch:{
			'mark.iconCheck':function(new_val, old_val){
				this.changeMark(new_val);
			},
			'person.country.cod_pais': function(new_val, old_val){
				let lang = 'en';
				if(new_val == 1 || new_val == 24){
		            lang = 'pt';
		        }else if(new_val == 3){
		            lang = 'fr';
		        }else if(new_val == 5){
		            lang = 'de';
		        }
				this.updateLocale(lang);
            }
		},
        components: {
            Datepicker,
        }
	}
</script>

<style scoped>
	@media only screen and (max-width: 750px) {
		#divCanvas{
			overflow-x: scroll;
		}
	}
	select.decorated option:hover {
	    box-shadow: 0 0 10px 100px #1882A8 inset;
	}
	.errors{
	    font-size: 15px;
	    color: red;
	}
</style>